api = require('../api.coffee').api()

class global.IntegrationsResource extends ResourceBase

  @authorize_salesforce: (success, failure, params = {}) ->
    api.post '/integrations/authorize_salesforce', params, { success, failure }

  @authorize_hubspot: (success, failure, params = {}) ->
    api.post '/integrations/authorize_hubspot', params, { success, failure }

  @authorize_rdstation: (success, failure, params = {}) ->
    api.post '/integrations/authorize_rdstation', params, { success, failure }

  @authorize_nylas: (success, failure, params = {}) ->
    api.post '/integrations/authorize_nylas', params, { success, failure }

  @s3PresignedUrl: (success, failure, params = {}) ->
    api.get '/integrations/s3_presigned_url', params, { success, failure }



// WEBPACK FOOTER //
// ./src/resources/integrations.coffee